import { createSelector } from 'reselect';
import { getGameStaticData } from '@gameday/utils/selectors/getGameStaticData';

export const getProbablePitchersState = createSelector(
    [getGameStaticData],
    (gameStaticData) => (
        {
            probablePitchers: gameStaticData.probablePitchers,
            teams: {
                away: gameStaticData.teams.away.abbreviation,
                home: gameStaticData.teams.home.abbreviation
            }
        }
    )
);
